<template>
  <div>
    <v-toolbar v-if="!hideToolbar" dense flat color="transparent">
      <v-toolbar-title>
        <slot name="toolbar-title"></slot>
      </v-toolbar-title>
      <v-toolbar-items>
        <slot name="after-title"></slot>
      </v-toolbar-items>
      <v-spacer/>
      <v-toolbar-items>
        <slot name="toolbar-items"></slot>
        <v-btn  @click="sidebar= !sidebar" color="primary" v-if="isMobile && !hideSidebar" icon>
          <v-icon> mdi-filter-menu</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-row>
      <v-col lg="12" cols="12" v-if="beforeContent">
        <slot name="before-content"></slot>
      </v-col>
      <v-col :lg="!isMobile && !hideSidebar?9:12">
        <slot name="main-content"></slot>
      </v-col>
      <v-col lg="3" v-if="!isMobile && !hideSidebar">
        <slot v-if="!isMobile" name="main-sidebar"></slot>
      </v-col>
    </v-row>
    <v-navigation-drawer app right v-if="isMobile && !hideSidebar" @close="$emit('sidebarClose')" v-model="sidebar">
      <v-btn fab small absolute top right style="top:5px" @click="sidebar =! sidebar">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <slot v-if="isMobile" name="main-sidebar"></slot>
    </v-navigation-drawer>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Page from "@/components/templates/Page";

export default {
  name: "SinglePage",
  components: {Page},
  data: () => ({
    sidebar: false,
  }),
  watch: {
    sidebarOverride() {
      this.sidebar = this.sidebarOverride;
    }
  },
  computed: {
    ...mapGetters([
      "isMobile"
    ])
  },
  props: {
    sidebarOverride: {type: Boolean, default: null, required: false},
    hideToolbar: {type: Boolean, default: false, required: false},
    isFullWidth: {type: Boolean, default: false, required: false},
    hideSidebar: {type: Boolean, default: false, required: false},
    beforeContent: {type: Boolean, default: null, required: false}
  }
}
</script>

<style scoped>

</style>
